import rest from '@/api/rest';
import User from '@/models/user';


async function load() {
  const users = Object.values(await rest.get('/admin/users'));
  User.create({data: users});
}

// { email, password, is_superuser }
async function create(data) {
  const user = await rest.post('/admin/users', data);
  User.insertOrUpdate({data: user});
  return user;
}

async function update(id, data) {

  const { role, ...cleaned } = data;
  // instructed to show "roles" frontend, but a superadmin flag instead of roles backend for the time being
  if (role == 'admin') {
    cleaned.is_superuser = true;
    cleaned.is_superadmin = false;
  } else if (role == 'superadmin') {
    cleaned.is_superuser = true;
    cleaned.is_superadmin = true;
  } else if (role == 'user') {
    cleaned.is_superuser = false;
    cleaned.is_superadmin = false;
  }
  const user = await rest.put(`/admin/users/${id}`, cleaned);
  User.insertOrUpdate({data: user});
  return user;
}

async function remove(id) {
  await rest.delete(`/admin/users/${id}`);
  User.delete(id);
}


export default {
  load,
  create,
  update,
  remove
};
